import React from "react";
import PropTypes from "prop-types";
import Heading from "@ui/heading";
import { useStaticQuery, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import { PageHeaderWrap } from "./style";

const PageHeader = ({ title }) => {
  const headerBg = useStaticQuery(graphql`
    {
      file(relativePath: { eq: "bg/header-bg.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            width: 1920
            height: 768
            placeholder: TRACED_SVG
            formats: WEBP
            quality: 100
          )
        }
      }
    }
  `);

  const bgImage = convertToBgImage(getImage(headerBg.file));

  return (
    <PageHeaderWrap {...bgImage}>
      <Heading as="h1" mt="40px">
        {title.toUpperCase()}
      </Heading>
    </PageHeaderWrap>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
};

export default PageHeader;
